import React from 'react';

import { Checkbox } from 'antd-v5';
import { Input } from 'scouting-ui/lib';

import styles from './DevMasqueradeFields.module.scss';

interface DevMasqueradeFieldsProps {
  masqueradeMode: boolean;
  masqueradeMemberId: string;
  disabled: boolean;
  onModeChange: (checked: boolean) => void;
  onMemberIdChange: (memberId: string) => void;
}

const DevMasqueradeFields: React.FC<DevMasqueradeFieldsProps> = ({
  masqueradeMode,
  masqueradeMemberId,
  disabled,
  onModeChange,
  onMemberIdChange,
}) => (
  <div className={styles.masqueradeContainer}>
    <label className={styles.masqueradeToggle}>
      <Checkbox
        checked={masqueradeMode}
        onChange={e => onModeChange(e.target.checked)}
      >
        Masquerade login
      </Checkbox>
    </label>
    {masqueradeMode && (
      <Input
        type="text"
        name="masqueradeMemberId"
        size="large"
        disabled={disabled}
        placeholder="Member ID"
        value={masqueradeMemberId}
        onChange={e => onMemberIdChange(e.target.value)}
      />
    )}
  </div>
);

export default DevMasqueradeFields;
